// MLS catalog store — server API mirror of the old localStorage `ira_mls__system`.
// Listing is public (signup MLS picker); mutations require a System session.
// Each call returns parsed JSON or throws ApiError (callers surface err.message).

import { api } from '../api';

export const mlsStore = {
  // Public — returns the shared MLS catalog (visible to every browser/user).
  async list() {
    const { mls } = await api.get('/api/mls');
    return mls;
  },

  async create({ name, description, signupTrialDays } = {}) {
    const { mls, systemOrgId } = await api.post('/api/mls', { name, description, signupTrialDays });
    return { mls, systemOrgId };
  },

  // patch: { name?, description?, signupTrialDays?(null=inherit), processSuspended?(null=inherit) }
  async update(id, patch) {
    const { mls } = await api.patch(`/api/mls/${id}`, patch);
    return mls;
  },

  async remove(id) {
    return api.delete(`/api/mls/${id}`);
  },
};
